export default __webpack_public_path__ + "static/media/newtons-cradle.91bc0e24.png";